import { jsx as _jsx } from "react/jsx-runtime";
export const SuccessIcon = (props) => {
    return (_jsx("svg", { width: "48", height: "48", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M18.0002 32.3399L9.66019 23.9999L6.82019 26.8199L18.0002 37.9999L42.0002 13.9999L39.1802 11.1799L18.0002 32.3399Z", fill: "#8AC170" }) }));
};
